import OutsideClickHandler from "react-outside-click-handler/build/OutsideClickHandler";
import WoDropdown from "./WoDropdown";

const AssignFormModal = ({
  isOpen,
  selectedWo,
  onClose,
  onWoSelect,
  onAssign,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed w-screen h-screen left-0 top-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
      <OutsideClickHandler onOutsideClick={onClose}>
        <div className="w-[436px] bg-white rounded-[6px] flex flex-col">

          <div className="border-b-[1px] border-borderColor py-3 px-4">
            <p className="text-[16px] font-OpenSansMedium font-[600] text-titleColor ">
              ASSIGN FORM TO WORK ORDER
            </p>
          </div>

          <div className="p-[18px]">
            <div className="w-full mb-4">
              <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor mb-2">
                Work Order # <span className="text-red-500">*</span>
              </p>
              <WoDropdown
                selectedValue={selectedWo}
                onSelect={onWoSelect}
                placeholder="Select work order"
              />
            </div>

            <div className="w-full mt-3">
              <div className="flex items-center justify-between gap-4">
                <div
                  onClick={onClose}
                  className="w-[50%] h-[30px] text-[10px] rounded-[6px] border-[1px] border-subTitleColor flex items-center justify-center text-subTitleColor cursor-pointer"
                >
                  CANCEL
                </div>
                <div
                  onClick={onAssign}
                  className={`w-[50%] h-[30px] text-[10px] rounded-[6px] flex items-center justify-center ${selectedWo?.id
                    ? "bg-blueColor text-white cursor-pointer"
                    : "bg-gray-300 text-white cursor-not-allowed"
                    }`}
                >
                  ASSIGN
                </div>
              </div>
            </div>
          </div>
        </div>
      </OutsideClickHandler>
    </div>
  );
};

export default AssignFormModal;
